import { CircularProgress, FormControl, MenuItem, Select } from "@mui/material";
import React, { useState } from "react";
import { Helper } from "../../../tools/Helper";
import { api_Routes } from "../../../tools/api_Routes";
import {
  errorToaster,
  successToaster,
} from "../../../helper/toasterConfiguration";
import StatusChangeModal from "./status-change-modal";
import { useDispatch } from "react-redux";
import { setOpen } from "../../../Redux/ModalReducer";

const PaymentStatusChanger = ({
  data,
  setData,
  rowsPerPage,
  currentPage,
  source = null,
  refetch = () => {},
}) => {
  const dispatch = useDispatch();
  const [isChangeStatusLoading, setIsChangeStatusLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [newStatus, setNewStatus] = useState();

  const handleOpen = () => {
    setShow(true);
    dispatch(setOpen(true));
  };

  const handleClose = () => {
    setShow(false);
    dispatch(setOpen(false));
  };

  const handleRowStatusChange = async (id, newStatus) => {
    setIsChangeStatusLoading(true);
    try {
      const {response} = await Helper.Post({
        url: `${api_Routes.Deposits.Edit}${id}`,
        data: {status: newStatus},
        hasToken: true,
      });

      if (response) {
        if (source !== null) {
          refetch();
        } else {
          // Fetch updated data in the background without affecting `isLoading`
          const {response: updatedData} = await Helper.Get({
            url: `${api_Routes.Deposits.View}?per_page=${rowsPerPage}&page=${
                currentPage + 1
            }`,
            hasToken: true,
          });

          if (updatedData) {
            setData(updatedData);
          } else {
            console.log(response)
          }
        }
        successToaster("The status update was successful");
      } else {
        setIsChangeStatusLoading(false);
        errorToaster("Failed to update the status");
      }
    }catch  (error) {
      console.log(error.response)
      errorToaster(error);
      // console.error("Error updating status:", error);
    } finally {
      setIsChangeStatusLoading(false);
    }
    handleClose();
    setIsChangeStatusLoading(false);
  };

  return (
    <>
      <FormControl size="small" className="w-full">
        <Select
          value={data?.status}
          onChange={(e) => {
            handleOpen();
            setNewStatus(e.target.value);
          }}
          sx={{
            borderRadius: "4px",
            height: "32px",
            fontSize: "0.875rem",
            "& .MuiOutlinedInput-notchedOutline": {
              border: "none",
            },
            "& .MuiSelect-select": {
              padding: "6px 32px 6px 12px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            },
            boxShadow: "none",
            ".MuiOutlinedInput-notchedOutline": { border: 0 },
            "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
              border: 0,
            },
            "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
              {
                border: 0,
              },
          }}
          MenuProps={{
            PaperProps: {
              sx: {
                marginTop: "4px",
                boxShadow: "0px 2px 4px rgba(0,0,0,0.1)",
                "& .MuiMenuItem-root": {
                  fontSize: "0.875rem",
                  minHeight: "32px",
                  justifyContent: "center",
                  "&:hover": {
                    backgroundColor: "#f5f5f5",
                  },
                },
              },
            },
          }}
          className={`w-full ${
            data?.status === "success"
              ? "bg-[#28a745] hover:bg-[#218838]"
              : data?.status === "pending"
              ? "bg-[#f7cb73] hover:bg-[#e5b965]"
              : "bg-[#ff6877] hover:bg-[#e65a68]"
          } text-darkTextColor transition-colors`}
        >
          <MenuItem value="success" className="text-sm">
            {isChangeStatusLoading ? (
              <div className="w-full flex justify-center">
                <CircularProgress size={18} sx={{ color: "white" }} />
              </div>
            ) : (
              "success"
            )}
          </MenuItem>
          <MenuItem value="pending" className="text-sm">
            {isChangeStatusLoading ? (
              <div className="w-full flex justify-center">
                <CircularProgress size={18} sx={{ color: "white" }} />
              </div>
            ) : (
              "Pending"
            )}
          </MenuItem>
          <MenuItem value="fail" className="text-sm">
            {isChangeStatusLoading ? (
              <div className="w-full flex justify-center">
                <CircularProgress size={18} sx={{ color: "white" }} />
              </div>
            ) : (
              "fail"
            )}
          </MenuItem>
        </Select>
      </FormControl>
      <StatusChangeModal
        show={show}
        handleClose={handleClose}
        handleSubmit={handleRowStatusChange}
        isLoading={isChangeStatusLoading}
        data={data}
        newStatus={newStatus}
      />
    </>
  );
};

export default PaymentStatusChanger;
